module.exports = __webpack_public_path__ + "img/gs4.3afdbda9.png";